import { useTranslation } from "react-i18next"

import { baseColumnDef } from "@/nzds/data-grid"
import { getDisplayValue } from "@/utils/value"

import type { GridColDef, GridValidRowModel } from "@mui/x-data-grid-pro"

interface UseMeterCodeColumnOptions {
  field?: string
  filterable?: boolean
}

export const useMeterCodeColumn = <TRow extends GridValidRowModel>(
  options: UseMeterCodeColumnOptions = {}
): GridColDef<TRow> => {
  const { t } = useTranslation("common")
  const field = options.field ?? "meter_code"
  const filterable = options.filterable ?? false

  return {
    ...baseColumnDef,
    field,
    filterable,
    flex: 1,
    headerName: t("fields.meterCode.title"),
    maxWidth: 240,
    minWidth: 140,
    sortable: true,
    valueFormatter: (value: string | null | undefined) =>
      getDisplayValue(value),
  }
}
